var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "19",
        viewBox: "0 0 16 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M3.42857 5.01801C3.42857 6.21148 3.9102 7.35607 4.76751 8.19999C5.62482 9.0439 6.78758 9.51801 8 9.51801C9.21242 9.51801 10.3752 9.0439 11.2325 8.19999C12.0898 7.35607 12.5714 6.21148 12.5714 5.01801C12.5714 3.82453 12.0898 2.67994 11.2325 1.83602C10.3752 0.992111 9.21242 0.518005 8 0.518005C6.78758 0.518005 5.62482 0.992111 4.76751 1.83602C3.9102 2.67994 3.42857 3.82453 3.42857 5.01801ZM6.80357 12.0563L7.46786 13.1461L6.27857 17.502L4.99286 12.3375C4.92143 12.0528 4.64286 11.8664 4.35357 11.9403C1.85357 12.5555 0 14.7844 0 17.4387C0 18.0364 0.492857 18.518 1.09643 18.518H5.80357C5.80357 18.518 5.80357 18.518 5.80714 18.518H6H10H10.1964C10.1964 18.518 10.1964 18.518 10.2 18.518H14.9036C15.5107 18.518 16 18.0328 16 17.4387C16 14.7844 14.1464 12.5555 11.6464 11.9403C11.3571 11.87 11.0786 12.0563 11.0071 12.3375L9.72143 17.502L8.53214 13.1461L9.19643 12.0563C9.425 11.6801 9.15 11.2055 8.70714 11.2055H8H7.29643C6.85357 11.2055 6.57857 11.6836 6.80714 12.0563H6.80357Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }